import { 
  saveStateWithAjax, 
  getPackageImageSource,  
  checkSubmit, 
  checkKey 
} from './screen-package-selection-global'

import {
  openConfigModal,
  getStoredComponentChoice,
  getStoredPackageChoice,
  getConfigModalState,
  clearStoredChoice
} from './screen-config-modal'

/* ============================================================
   RULE CONFIG
============================================================ */

// DEBUG: Expose functions to DevTools console
window.__Q7Q9__ = window.__Q7Q9__ || {}
window.__Q7Q9__.saveStateWithAjax = saveStateWithAjax
window.__Q7Q9__.checkSubmit = checkSubmit
window.__Q7Q9__.getPackageImageSource = getPackageImageSource

const DEBUG_Q7Q9 = false
function dbg(...args) {
  if (DEBUG_Q7Q9) {
    console.log('[Q7Q9]', ...args)
  }
}

const Q7Q9_MODEL_IDS = ['115', '116', '117', '118', '119', '120']

function getCarmodelId() {
	return document.querySelector('input[name="carmodel"]')?.value || ''
}

function isQ7Q9Model() {
	return ['115', '116', '117', '118', '119', '120'].includes(getCarmodelId())
}

/* nur bei der Standardversion werden die Lenkräder im Popup abgefragt */
function shouldShowSteeringWheelInPopup() {
	return getCarmodelId() === '115' || getCarmodelId() === '118'
}

const BASE_COLOR_VALUE_BY_MODE = {
  PWB_JV: '199',
  PWD_QM: '98',
  PWD_QX: '213'
}
const RESET_PACKAGE_CODES = ['PWB_JV', 'PWD_QM', 'PWD_QX']
const NEXT_BUTTON_STATUS_SESSION_CODES = [
    '97R_Q7Q9_status',
    '7HH_status',
    '7HF_status'
]

const BASE_COLOR_VALUES = Object.values(BASE_COLOR_VALUE_BY_MODE)
const SEAT_CONFIG = window.q7SeatConfig || '0'

const Q7Q9_FOLLOWUP_PACKAGE_CODES = [
  '7HH_Q7Q9',
  '7HF_Q7Q9',
  '7HM_Q7Q9'
]

const DEFAULT_Q7Q9_FOLLOWUP_PACKAGE_CODE = '7HM_Q7Q9'
const DEFAULT_Q7Q9_STEERING_WHEEL_CODE = '104'
const Q7Q9_STEERING_WHEEL_GROUP_ID = 'q7q9_steering_wheel'
const Q7Q9_FOLLOWUP_MODAL_GROUP_IDS = [
  'q7q9_yn1_package_choice',
  'q7q9_yn2_package_choice',
  'q7q9_yfa_package_choice',
  'q7q9_yfa_pwd_qx_package_choice'
]

const q7q9Runtime = {
  frontCheckboxesMap: null,
  engine: null
}

const q7q9Memory = {
  lastPWDQXSelection: null,
  baseColorByMode: {
    PWB_JV: BASE_COLOR_VALUE_BY_MODE.PWB_JV,
    PWD_QM: BASE_COLOR_VALUE_BY_MODE.PWD_QM,
    PWD_QX: BASE_COLOR_VALUE_BY_MODE.PWD_QX
  }
}

const persistQueue = {
  runId: 0
}

const RULES_Q7Q9 = {
  modeGroup: ['PWB_JV', 'PWD_QM', 'PWD_QX'],

  modes: {
    /* ======================= PWB_JV ======================= */
    PWB_JV: {
      defaultOnFirstLoad: true,
      disableMode: ['0UB_Q7Q9', 'YFA_Q7Q9', 'YN2_Q7Q9'],
      rules: [
        { type: 'disableTargets', ifOn: 'YN1_Q7Q9', disable: ['YN2_Q7Q9', 'YFA_Q7Q9', '0UB_Q7Q9'] },
        { type: 'disableTargets', ifOn: 'YFB_Q7Q9', disable: ['YN1_Q7Q9', 'YN2_Q7Q9', 'YFA_Q7Q9', '0UB_Q7Q9'] },
        /*{ type: 'disableTargets', ifOn: '97R_Q7Q9', disable: ['YN1_Q7Q9', 'YFB_Q7Q9'] },*/
        { type: 'disableTargets', ifOn: '7HH_Q7Q9', disable: ['7HF_Q7Q9','7HM_Q7Q9'] },
        { type: 'disableTargets', ifOn: '7HF_Q7Q9', disable: ['7HH_Q7Q9','7HM_Q7Q9'] },
        { type: 'disableTargets', ifOn: '7HM_Q7Q9', disable: ['7HH_Q7Q9','7HF_Q7Q9'] },
        { type: 'disableTargets', ifOn: 'FZ8_Q7Q9', disable: ['FZ9_Q7Q9'] },
        { type: 'disableTargets', ifOn: 'FZ9_Q7Q9', disable: ['FZ8_Q7Q9'] },
        /*{ type: 'disableTargets', ifOn: '0TF_Q7Q9', disable: ['YN1_Q7Q9', 'YFB_Q7Q9'] },*/

        { type: 'requires', ifOn: 'YFB_Q7Q9', thenOn: ['YN1_Q7Q9'] },
        { type: 'requires', ifOn: 'YN1_Q7Q9', thenOn: ['97R_Q7Q9', '0TF_Q7Q9'] }
        
      ]
    },

    /* ======================= PWD_QM ======================= */
    PWD_QM: {
      disableMode: ['YN1_Q7Q9'],
      rules: [
        { type: 'disableTargets', ifOn: '0UB_Q7Q9', disable: ['YN2_Q7Q9', 'YFB_Q7Q9'] },
        { type: 'disableTargets', ifOn: 'YN2_Q7Q9', disable: ['YFA_Q7Q9','0UB_Q7Q9'] },
        { type: 'disableTargets', ifOn: 'YFB_Q7Q9', disable: ['YN2_Q7Q9','YFA_Q7Q9','0UB_Q7Q9'] },
        { type: 'disableTargets', ifOn: 'YFA_Q7Q9', disable: ['YN2_Q7Q9', 'YFB_Q7Q9'] },
       /* { type: 'disableTargets', ifOn: '97R_Q7Q9', disable: ['YN2_Q7Q9', 'YFB_Q7Q9'] },*/
        { type: 'disableTargets', ifOn: '7HH_Q7Q9', disable: ['7HF_Q7Q9','7HM_Q7Q9'/*,'YN2_Q7Q9', 'YFB_Q7Q9'*/] },
        { type: 'disableTargets', ifOn: '7HF_Q7Q9', disable: ['7HH_Q7Q9','7HM_Q7Q9'/*,'YN2_Q7Q9', 'YFB_Q7Q9'*/] },
        { type: 'disableTargets', ifOn: '7HM_Q7Q9', disable: ['7HH_Q7Q9','7HF_Q7Q9'/*,'YN2_Q7Q9', 'YFB_Q7Q9'*/] },
        { type: 'disableTargets', ifOn: 'FZ8_Q7Q9', disable: ['FZ9_Q7Q9'] },
        { type: 'disableTargets', ifOn: 'FZ9_Q7Q9', disable: ['FZ8_Q7Q9'] },
       /* { type: 'disableTargets', ifOn: '0TF_Q7Q9', disable: ['YN2_Q7Q9', 'YFB_Q7Q9'] },*/

        { type: 'requires', ifOn: 'YFB_Q7Q9', thenOn: ['YN2_Q7Q9'] },
        { type: 'requires', ifOn: 'YFA_Q7Q9', thenOn: ['0UB_Q7Q9','97R_Q7Q9','0TF_Q7Q9'] },
        { type: 'requires', ifOn: 'YN2_Q7Q9', thenOn: ['97R_Q7Q9', '0TF_Q7Q9'] }
      ]
    },

    /* ======================= PWD_QX ======================= */
    PWD_QX: {
      disableMode: ['YN1_Q7Q9','YN2_Q7Q9','YFB_Q7Q9'],
      rules: [
        { type: 'disableTargets', ifOn: '7HH_Q7Q9', disable: ['7HF_Q7Q9','7HM_Q7Q9'] },
        { type: 'disableTargets', ifOn: '7HF_Q7Q9', disable: ['7HH_Q7Q9','7HM_Q7Q9'] },
        { type: 'disableTargets', ifOn: '7HM_Q7Q9', disable: ['7HH_Q7Q9','7HF_Q7Q9'] },
        { type: 'disableTargets', ifOn: 'FZ8_Q7Q9', disable: ['FZ9_Q7Q9'] },
        { type: 'disableTargets', ifOn: 'FZ9_Q7Q9', disable: ['FZ8_Q7Q9'] },

        { type: 'requires', ifOn: 'YFA_Q7Q9', thenOn: ['0UB_Q7Q9','97R_Q7Q9','0TF_Q7Q9'] },
      ]
    }
  }
}

/* ============================================================
   DOM HELPERS
============================================================ */

function resetAllOtherPackages(clickedCode) {
  if (!RESET_PACKAGE_CODES.includes(clickedCode)) return

  document.querySelectorAll('label[data-auicode] input[type="checkbox"]').forEach((input) => {
    const label = input.closest('label[data-auicode]')
    const code = label?.dataset?.auicode

    if (!code || code === clickedCode) return

    input.checked = false
    label.classList.remove('is-checked')
  })
}

function resetNextButtonSessionStatuses() {
  NEXT_BUTTON_STATUS_SESSION_CODES.forEach((sessionCode) => {
    const xhr = new XMLHttpRequest()
    xhr.open('POST', 'update_next_button.php', true)
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')

    const data =
      'action=unsetSessionVariable' +
      '&package=' + encodeURIComponent(sessionCode)

    xhr.send(data)
  })
}

function getLabelFor(mapVal, key) {
  if (mapVal?.tagName === 'LABEL') return mapVal
  if (mapVal?.tagName === 'INPUT') return mapVal.closest('label[data-auicode]')
  return document.querySelector(`label[data-auicode="${key}"]`)
}

function getInputFor(mapVal, key) {
  if (mapVal?.tagName === 'INPUT') return mapVal
  if (mapVal?.tagName === 'LABEL') return mapVal.querySelector('input')
  return document.querySelector(`label[data-auicode="${key}"] input`)
}

function setChecked(map, key, checked) {
  const input = getInputFor(map[key], key)
  const label = getLabelFor(map[key], key)
  if (!input) return

  input.checked = checked
  label?.classList.toggle('is-checked', checked)
}

function setDisabled(map, key, disabled) {
  const input = getInputFor(map[key], key)
  if (input) input.disabled = disabled
}

function setHidden(map, key, hidden) {
  const label = getLabelFor(map[key], key)
  if (!label) return

  label.style.display = hidden ? 'none' : ''
}

function setForcedBadge(map, key, forced) {
  const label = getLabelFor(map[key], key)
  label?.classList.toggle('is-forced', forced)
}

function isSelected(map, id) {
  const input = getInputFor(map[id], id)
  const label = getLabelFor(map[id], id)
  if (!input) return false
  return !!input.checked || !!label?.classList?.contains('is-checked')
}

function snapshotState(map) {
  const state = {}
  for (const id of Object.keys(map)) {
    state[id] = isSelected(map, id)
  }
  return state
}

function getAllInputsFromMap(map) {
  return Object.keys(map)
    .map(key => getInputFor(map[key], key))
    .filter(Boolean)
}

function getLabelForInput(input) {
  return input ? input.closest('label[data-auicode]') : null
}

function clearFollowupPackageIfTriggerWasDeselected(map, changedId) {
  const triggerCodes = ['YN1_Q7Q9', 'YN2_Q7Q9', 'YFA_Q7Q9']

  if (!triggerCodes.includes(changedId)) return
  if (isSelected(map, changedId)) return

  Q7Q9_FOLLOWUP_PACKAGE_CODES.forEach(code => {
    setChecked(map, code, false)
    setDisabled(map, code, false)
    setForcedBadge(map, code, false)
    saveStateWithAjax(code, false)
  })
}


/* ============================================================
   BASE COLORS (BY INPUT VALUE)
============================================================ */

function getCurrentMode(map) {
  return RULES_Q7Q9.modeGroup.find(code => isSelected(map, code)) || null
}

function isBaseColorValue(value) {
  return BASE_COLOR_VALUES.includes(String(value))
}

function findInputByValue(map, value) {
  const wanted = String(value)
  return getAllInputsFromMap(map).find(input => String(input.value) === wanted) || null
}

function getSelectedBaseColorValue(map) {
  const selected = getAllInputsFromMap(map).find(input => {
    return input.checked && isBaseColorValue(input.value)
  })
  return selected ? String(selected.value) : null
}

function rememberSpecificModeBaseColor(mode, colorValue) {
  if (!mode || colorValue == null) return
  q7q9Memory.baseColorByMode[mode] = String(colorValue)
  dbg('rememberSpecificModeBaseColor', { mode, colorValue: String(colorValue) })
}

function setExclusiveBaseColorByValue(map, colorValue) {
  const target = String(colorValue)

  getAllInputsFromMap(map).forEach(input => {
    if (!isBaseColorValue(input.value)) return

    const checked = String(input.value) === target
    input.checked = checked

    const label = getLabelForInput(input)
    label?.classList.toggle('is-checked', checked)
  })

  dbg('setExclusiveBaseColorByValue', target)
}

function applyRememberedOrDefaultBaseColor(map, mode) {
  if (!mode) return

  const remembered = q7q9Memory.baseColorByMode[mode]
  const fallback = BASE_COLOR_VALUE_BY_MODE[mode]
  const targetValue = String(remembered || fallback || '')

  if (!targetValue) return

  const targetInput = findInputByValue(map, targetValue)
  if (!targetInput) {
    dbg('applyRememberedOrDefaultBaseColor skipped, value missing in DOM', { mode, targetValue })
    return
  }

  setExclusiveBaseColorByValue(map, targetValue)
  dbg('applyRememberedOrDefaultBaseColor', { mode, targetValue })
}

function enforceActiveModeBaseColor(map) {
  const currentMode = getCurrentMode(map)
  if (!currentMode) return
  applyRememberedOrDefaultBaseColor(map, currentMode)
}

/* ============================================================
   MODE MEMORY (PWD_QX)
============================================================ */

function rememberPWDQXSelection(map) {
  if (!isSelected(map, 'PWD_QX')) {
    dbg('rememberPWDQXSelection skipped, PWD_QX not active')
    return
  }

  /*
  if (isSelected(map, 'YN2_Q7Q9')) {
    q7q9Memory.lastPWDQXSelection = 'YN2_Q7Q9'
    dbg('rememberPWDQXSelection -> YN2_Q7Q9')
    return
  }

  if (isSelected(map, 'YFB_Q7Q9')) {
    q7q9Memory.lastPWDQXSelection = 'YFB_Q7Q9'
    dbg('rememberPWDQXSelection -> YFB_Q7Q9')
    return
  }
  */

  dbg('rememberPWDQXSelection -> keep', q7q9Memory.lastPWDQXSelection)
}

function restorePWDQXSelection(map) {
  if (!isSelected(map, 'PWD_QX')) return
  if (!q7q9Memory.lastPWDQXSelection) return

  if (q7q9Memory.lastPWDQXSelection === 'YN2_Q7Q9') {
    setChecked(map, 'YN2_Q7Q9', true)
    dbg('restorePWDQXSelection <- YN2_Q7Q9')
  }

  if (q7q9Memory.lastPWDQXSelection === 'YFB_Q7Q9') {
    setChecked(map, 'YFB_Q7Q9', true)
    dbg('restorePWDQXSelection <- YFB_Q7Q9')
  }
}

function clearPWDQXMemoryOnExplicitDeselect(map, changedId) {
  if (!isSelected(map, 'PWD_QX')) return

  if (changedId === 'YN2_Q7Q9' && !isSelected(map, 'YN2_Q7Q9')) {
    q7q9Memory.lastPWDQXSelection = null
    dbg('clearPWDQXMemoryOnExplicitDeselect -> YN2_Q7Q9 cleared')
    return
  }

  if (changedId === 'YFB_Q7Q9' && !isSelected(map, 'YFB_Q7Q9')) {
    q7q9Memory.lastPWDQXSelection = null
    dbg('clearPWDQXMemoryOnExplicitDeselect -> YFB_Q7Q9 cleared')
  }
}

/* ============================================================
   PERSIST
============================================================ */

function persistAllStates(map) {
  const allIds = Object.keys(map)

  const priorityIds = [
    'PWB_JV',
    'PWD_QM',
    'PWD_QX',
    'YN1_Q7Q9',
    'YN2_Q7Q9',
    'YFB_Q7Q9',
    'YFA_Q7Q9',
    '7HH_Q7Q9',
    '7HF_Q7Q9',
    '7HM_Q7Q9',
    '97R_Q7Q9',
    '0TF_Q7Q9',
    '0UB_Q7Q9',
    'FZ8_Q7Q9',
    'FZ9_Q7Q9'
  ].filter(id => allIds.includes(id))

  const priorityFalse = priorityIds.filter(id => !isSelected(map, id))
  const priorityTrue = priorityIds.filter(id => isSelected(map, id))
  const rest = allIds.filter(id => !priorityIds.includes(id))

  const orderedIds = [...priorityFalse, ...priorityTrue, ...rest]

  const currentRunId = ++persistQueue.runId
  const delayMs = 35

  function sendNext(index) {
    if (currentRunId !== persistQueue.runId) {
      dbg('persist aborted by newer run')
      return
    }

    if (index >= orderedIds.length) {
      dbg('persist finished', orderedIds)
      return
    }

    const id = orderedIds[index]
    const checked = isSelected(map, id)

    dbg('persist', index, id, checked)
    saveStateWithAjax(id, checked)

    setTimeout(() => {
      sendNext(index + 1)
    }, delayMs)
  }

  sendNext(0)
}

/* ============================================================
   NORMALIZE / SPECIAL
============================================================ */

function normalizeSelected(selected, modeCfg, options = {}) {
  const { initial = false } = options
  if (!initial) return
}

function applySpecialBackPropagation_q7q9(map, changedId) {
  if (changedId !== 'YFA_Q7Q9') return

  const yfaOn = isSelected(map, 'YFA_Q7Q9')
  const linked = ['97R_Q7Q9', '0TF_Q7Q9']

  linked.forEach(id => {
    if (map[id]) {
      setChecked(map, id, yfaOn)
    }
  })
}

function applySpecialModalDependencies_q7q9(map) {
  const yn1On = isSelected(map, 'YN1_Q7Q9')
  const yn2On = isSelected(map, 'YN2_Q7Q9')
  const yfbOn = isSelected(map, 'YFB_Q7Q9')
  const yfaOn = isSelected(map, 'YFA_Q7Q9')

  const shouldLockFollowup = yn1On || yn2On || yfbOn || yfaOn

  if (!shouldLockFollowup) return

  const activeFollowupPackage = Q7Q9_FOLLOWUP_PACKAGE_CODES.find(code => isSelected(map, code))

  if (!activeFollowupPackage) return

  Q7Q9_FOLLOWUP_PACKAGE_CODES.forEach(code => {
    setDisabled(map, code, true)
    setForcedBadge(map, code, code === activeFollowupPackage)
  })
}

function updateSubmitButton_q7q9(frontCheckboxesMap, options = {}) {
  const { initial = false } = options

  const btn = document.getElementById('navigation-submit-btn')
  if (!btn) return

  const ids = Object.keys(frontCheckboxesMap)
  const modeSet = new Set(RULES_Q7Q9.modeGroup || [])

  const selected = ids.filter(id => !modeSet.has(id) && isSelected(frontCheckboxesMap, id))

  if (initial) {
    btn.disabled = true
    return
  }

  btn.disabled = selected.length === 0
}

/* ============================================================
   ENGINE
============================================================ */

function ensureMode(selected, config, ctx) {
  const modes = config.modeGroup

  if (ctx?.lastClicked && modes.includes(ctx.lastClicked)) {
    selected.add(ctx.lastClicked)
    for (const id of modes) {
      if (id !== ctx.lastClicked) selected.delete(id)
    }
    return ctx.lastClicked
  }

  let active = modes.find(id => selected.has(id))

  if (!active) {
    const def = modes.find(id => config.modes[id]?.defaultOnFirstLoad)
    active = def || modes[0]
    selected.add(active)
  }

  for (const id of modes) {
    if (id !== active) selected.delete(id)
  }

  return active
}

function resolveExclude(a, b, ctx, forced) {
  if (forced.has(a)) return b
  if (forced.has(b)) return a
  if (ctx.lastClicked === a) return b
  if (ctx.lastClicked === b) return a
  return b
}

function computeState(map, config, ctx, options = {}) {
  const ids = Object.keys(map)
  const selected = new Set()

  const snapshot = {}
  for (const id of ids) {
    snapshot[id] = isSelected(map, id)
    if (snapshot[id]) selected.add(id)
  }

  dbg('DOM STATE BEFORE COMPUTE', snapshot)

  const disabled = new Set()
  const hidden = new Set()
  const forced = new Set()

  const mode = ensureMode(selected, config, ctx)
  const modeCfg = config.modes[mode] || {}

  normalizeSelected(selected, modeCfg, options)

  dbg('Active mode:', mode)
  dbg('Selected after normalize:', [...selected])

  for (const id of (modeCfg.disableMode || [])) {
    disabled.add(id)
    hidden.add(id)
    selected.delete(id)
  }

  let changed = true
  let guard = 0

  while (changed && guard++ < 50) {
    changed = false

    for (const r of (modeCfg.rules || [])) {
      if (r.type === 'disableTargets' && selected.has(r.ifOn)) {
        for (const t of (r.disable || [])) {
          if (!disabled.has(t)) {
            disabled.add(t)
            changed = true
          }
          if (selected.delete(t)) {
            changed = true
          }
        }
      }
    }

    const activeAllowOnly = (modeCfg.rules || []).filter(r => r.type === 'allowOnly' && selected.has(r.ifOn))
    if (activeAllowOnly.length) {
      let allowed = new Set(ids)

      for (const r of activeAllowOnly) {
        const thisAllowed = new Set([...config.modeGroup, r.ifOn, ...(r.allow || [])])
        allowed = new Set([...allowed].filter(x => thisAllowed.has(x)))
      }

      for (const id of ids) {
        if (!allowed.has(id)) {
          if (!disabled.has(id)) {
            disabled.add(id)
            changed = true
          }
          if (selected.delete(id)) {
            changed = true
          }
        }
      }
    }

    for (const r of (modeCfg.rules || [])) {
      if (r.type === 'requires' && selected.has(r.ifOn)) {
        for (const dep of (r.thenOn || [])) {
          if (disabled.has(dep)) {
            disabled.delete(dep)
            changed = true
          }
          if (!selected.has(dep)) {
            selected.add(dep)
            changed = true
          }
          if (!forced.has(dep)) {
            forced.add(dep)
            changed = true
          }
        }
      }
    }

    for (const r of (modeCfg.rules || [])) {
      if (r.type === 'excludes' && selected.has(r.a) && selected.has(r.b)) {
        const drop = resolveExclude(r.a, r.b, ctx, forced)
        if (selected.delete(drop)) {
          changed = true
        }
      }
    }

    for (const id of disabled) {
      if (selected.delete(id)) {
        changed = true
      }
    }
  }

  for (const id of config.modeGroup) {
    forced.delete(id)
  }

  dbg('FINAL STATE', {
    selected: [...selected],
    disabled: [...disabled],
    hidden: [...hidden],
    forced: [...forced]
  })

  return { selected, disabled, hidden, forced }
}

function applyState(map, state, options = {}) {
  dbg('APPLY STATE', {
    selected: [...state.selected],
    disabled: [...state.disabled],
    hidden: [...state.hidden],
    forced: [...state.forced],
    options
  })

  for (const id of Object.keys(map)) {
    const shouldCheck = state.selected.has(id)
    const shouldDisable = state.disabled.has(id) || state.forced.has(id)
    const shouldHide = state.hidden.has(id)

    setChecked(map, id, shouldCheck)
    setDisabled(map, id, shouldDisable)
    setHidden(map, id, shouldHide)
    setForcedBadge(map, id, state.forced.has(id))
  }

  applySpecialModalDependencies_q7q9(map)

  enforceActiveModeBaseColor(map)

  updateBackgroundImage()
  getImages_q7q9(map)
  checkSubmit(map)
  updateSubmitButton_q7q9(map, options)
}

function createEngine(config) {
  const ctx = { lastClicked: null }

  function recompute(map, changedId = null, options = {}) {
    if (changedId) {
      ctx.lastClicked = changedId
    }

    dbg('RECOMPUTE', { changedId, options })

    const state = computeState(map, config, ctx, options)
    applyState(map, state, options)
    return state
  }

  return { recompute }
}

/* ============================================================
   LISTENERS / LOCKS
============================================================ */

function addListeners_q7q9(frontCheckboxesMap, modalsCheckboxesMap, config = RULES_Q7Q9) {
  try {
    if (typeof checkKey === 'function') {
      checkKey(frontCheckboxesMap)
      dbg('checkKey initialized')
    } else {
      dbg('checkKey not available')
    }
  } catch (e) {
    console.error('[Q7Q9] checkKey ERROR', e)
  }

  const engine = createEngine(config)
  q7q9Runtime.frontCheckboxesMap = frontCheckboxesMap
  q7q9Runtime.engine = engine

  const ids = Object.keys(frontCheckboxesMap)

  for (const id of ids) {
    const input = getInputFor(frontCheckboxesMap[id], id)
    if (!input) continue

    input.addEventListener('change', function () {
      setTimeout(() => {
        const stateBeforeChange = snapshotState(frontCheckboxesMap)

        dbg('CHANGE start', id, stateBeforeChange)

        const isModeSwitch = config.modeGroup.includes(id)
        const selectedBaseColorValueBefore = getSelectedBaseColorValue(frontCheckboxesMap)

        if (selectedBaseColorValueBefore) {
          const currentModeBefore = getCurrentMode(frontCheckboxesMap)
          if (currentModeBefore) {
            rememberSpecificModeBaseColor(currentModeBefore, selectedBaseColorValueBefore)
          }
        }

        rememberPWDQXSelection(frontCheckboxesMap)

        if (RESET_PACKAGE_CODES.includes(id) && input.checked) {
          resetAllOtherPackages(id)
          resetNextButtonSessionStatuses()
        }


        engine.recompute(frontCheckboxesMap, id, { initial: false })

        if (isModeSwitch) {
          applyRememberedOrDefaultBaseColor(frontCheckboxesMap, id)
        }

        clearPWDQXMemoryOnExplicitDeselect(frontCheckboxesMap, id)

        if (id === 'PWD_QX') {
          restorePWDQXSelection(frontCheckboxesMap)
          engine.recompute(frontCheckboxesMap, id, { initial: false })
          applyRememberedOrDefaultBaseColor(frontCheckboxesMap, 'PWD_QX')
        }

        applySpecialBackPropagation_q7q9(frontCheckboxesMap, id)
        clearFollowupPackageIfTriggerWasDeselected(frontCheckboxesMap, id)

        engine.recompute(frontCheckboxesMap, id, { initial: false })

        /* Aufruf popups */
        maybeOpenPwbYn1FollowupModal(id, stateBeforeChange)
        maybeOpenPwdQmYn2FollowupModal(id, stateBeforeChange)
        maybeOpenPwdQmYfaFollowupModal(id)
        maybeOpenPwdQxYfaFollowupModal(id)
        /* Aufruf popups */

        const selectedBaseColorValueAfter = getSelectedBaseColorValue(frontCheckboxesMap)
        const currentModeAfter = getCurrentMode(frontCheckboxesMap)
        if (currentModeAfter && selectedBaseColorValueAfter) {
          rememberSpecificModeBaseColor(currentModeAfter, selectedBaseColorValueAfter)
        }

        enforceActiveModeBaseColor(frontCheckboxesMap)
        rememberPWDQXSelection(frontCheckboxesMap)
        persistAllStates(frontCheckboxesMap)

        checkSubmit(frontCheckboxesMap)
        updateSubmitButton_q7q9(frontCheckboxesMap, { initial: false })

        dbg('CHANGE end', id, snapshotState(frontCheckboxesMap))
      }, 0)
    })
  }

  setTimeout(() => {
    dbg('INIT before', snapshotState(frontCheckboxesMap))

    engine.recompute(frontCheckboxesMap, null, { initial: true })

    const initialMode = getCurrentMode(frontCheckboxesMap) || 'PWB_JV'
    applyRememberedOrDefaultBaseColor(frontCheckboxesMap, initialMode)

    const initialBaseColorValue = getSelectedBaseColorValue(frontCheckboxesMap)
    if (initialBaseColorValue) {
      rememberSpecificModeBaseColor(initialMode, initialBaseColorValue)
    }

    rememberPWDQXSelection(frontCheckboxesMap)

    checkSubmit(frontCheckboxesMap)
    updateSubmitButton_q7q9(frontCheckboxesMap, { initial: false })

    dbg('INIT after', snapshotState(frontCheckboxesMap))
  }, 0)
}

function checkLocks_q7q9(frontCheckboxesMap, modalsCheckboxesMap, config = RULES_Q7Q9) {
  const engine = createEngine(config)
  return engine.recompute(frontCheckboxesMap, null, { initial: false })
}

/* ============================================================
   IMAGES
============================================================ */

function getImages_q7q9(map) {
  for (const id in map) {
    getPackageImages_q7q9(id, map)
  }
}

function getPackageImages_q7q9(packageCode, map) {
  const input = getInputFor(map[packageCode], packageCode)
  if (!input) return

  const imageSource = getPackageImageSource(packageCode)
  let img = document.getElementById(packageCode + '-img')

  if (!img && input.checked) {
    const wrap = document.querySelector('.image-wrap')
    if (!wrap) return

    const newImg = document.createElement('img')
    newImg.classList.add('overlay')
    newImg.src = imageSource
    newImg.id = packageCode + '-img'
    wrap.appendChild(newImg)
    img = newImg
  }

  if (img) {
    img.hidden = !input.checked
  }
}

/* ============================================================
   SHARED Q7Q9 FOLLOWUP MODAL
============================================================ */

function getConfigModalTranslation(key, fallback) {
  return window.configModalTranslations?.[key] || fallback
}

function getActiveQ7Q9FollowupPackageCode() {
  return Q7Q9_FOLLOWUP_PACKAGE_CODES.find(code => {
    const input = document.querySelector(`label[data-auicode="${code}"] input`)
    return !!input?.checked
  }) || null
}

function getSelectionCode(selections, groupId) {
  if (Array.isArray(selections)) {
    return selections.find(entry => entry.id === groupId)?.code || null
  }

  return selections?.[groupId] || null
}

function clearSelectedQ7Q9PackagesExceptMode() {
  document.querySelectorAll('label[data-auicode] input[type="checkbox"]').forEach((input) => {
    const label = input.closest('label[data-auicode]')
    const code = label?.dataset?.auicode

    if (!code || RESET_PACKAGE_CODES.includes(code)) return
    if (!input.checked && !label?.classList.contains('is-checked')) return

    input.checked = false
    input.disabled = false
    label?.classList.remove('is-checked', 'is-forced')

    saveStateWithAjax(code, false)
  })

  Q7Q9_FOLLOWUP_MODAL_GROUP_IDS.forEach(groupId => clearStoredChoice(groupId))

  if (q7q9Runtime.engine && q7q9Runtime.frontCheckboxesMap) {
    q7q9Runtime.engine.recompute(q7q9Runtime.frontCheckboxesMap, null, { initial: false })
    persistAllStates(q7q9Runtime.frontCheckboxesMap)
    checkSubmit(q7q9Runtime.frontCheckboxesMap)
    updateSubmitButton_q7q9(q7q9Runtime.frontCheckboxesMap, { initial: false })
  }
}

function applyQ7Q9FollowupPackageChoice(selectedCode) {
  if (!Q7Q9_FOLLOWUP_PACKAGE_CODES.includes(selectedCode)) return

  Q7Q9_FOLLOWUP_PACKAGE_CODES.forEach(code => {
    const input = document.querySelector(`label[data-auicode="${code}"] input`)
    const label = document.querySelector(`label[data-auicode="${code}"]`)

    if (!input) return

    const checked = code === selectedCode

    input.checked = checked
    input.disabled = checked

    label?.classList.toggle('is-checked', checked)
    label?.classList.toggle('is-forced', checked)
  })

  saveStateWithAjax(selectedCode, true)

  Q7Q9_FOLLOWUP_PACKAGE_CODES
    .filter(code => code !== selectedCode)
    .forEach(code => saveStateWithAjax(code, false))
}

function openQ7Q9FollowupModal(groupId, logLabel = 'Q7Q9 Modal', triggerCode = null) {
  const isPwdQxActive = !!document.querySelector('label[data-auicode="PWD_QX"] input')?.checked
  const isPwdQmActive = !!document.querySelector('label[data-auicode="PWD_QM"] input')?.checked
  const isYfaQ7q9Active = !!document.querySelector('label[data-auicode="YFA_Q7Q9"] input')?.checked
  const activeFollowupPackageCode = getActiveQ7Q9FollowupPackageCode()
  const defaultFollowupPackageCode = activeFollowupPackageCode || DEFAULT_Q7Q9_FOLLOWUP_PACKAGE_CODE

  let packageOptions = [
    {
      code: '7HM_Q7Q9',
      label: window.packageTranslations?.['7HM_Q7Q9'] || '7HM_Q7Q9',
      default: defaultFollowupPackageCode === '7HM_Q7Q9'
    },
    {
      code: '7HH_Q7Q9',
      label: window.packageTranslations?.['7HH_Q7Q9'] || '7HH_Q7Q9',
      default: defaultFollowupPackageCode === '7HH_Q7Q9'
    },
    {
      code: '7HF_Q7Q9',
      label: window.packageTranslations?.['7HF_Q7Q9'] || '7HF_Q7Q9',
      default: defaultFollowupPackageCode === '7HF_Q7Q9'
    }
  ]

  // In PWD_QX gibt es 7HM nicht
  if (isPwdQxActive ||  (isPwdQmActive && isYfaQ7q9Active)) {
    packageOptions = packageOptions.filter(opt => opt.code !== '7HM_Q7Q9')

    if (!activeFollowupPackageCode) {
      const fallbackOption = packageOptions.find(opt => opt.code === '7HH_Q7Q9')
      if (fallbackOption) fallbackOption.default = true
    }
  }

  // Wichtig: Das Modal darf keinen alten sessionStorage-Wert bevorzugen,
  // wenn im DOM bereits 7HH/7HF/7HM aktiv ist. Quelle der Wahrheit ist hier
  // der aktuelle Paketstatus; sonst fällt es auf den Default 7HM zurück.
  clearStoredChoice(groupId)

  const groups = [
    {
      id: groupId,
      type: 'package',
      title: getConfigModalTranslation('followupPackageTitle', 'Bitte wählen Sie die gewünschte Ausführung'),
      options: packageOptions
    }
  ]

  // Nur Fahrzeug 115 bekommt zusätzlich die Lenkrad-Auswahl
  if (shouldShowSteeringWheelInPopup()) {
    groups.push({
      id: Q7Q9_STEERING_WHEEL_GROUP_ID,
      type: 'component',
      title: getConfigModalTranslation('steeringWheelTitle', 'Lenkradwahl'),
      options: [
        {
          code: '104',
          label: getConfigModalTranslation('steeringWheel104', '...'),
          default: DEFAULT_Q7Q9_STEERING_WHEEL_CODE === '104'
        },
        {
          code: '105',
          label: getConfigModalTranslation('steeringWheel105', '...'),
          default: DEFAULT_Q7Q9_STEERING_WHEEL_CODE === '105'
        }
      ]
    })
  }

  openConfigModal({
    title: getConfigModalTranslation('followupTitle', 'Diese Auswahl erfordert weitere Anpassungen Ihrer Konfiguration'),
    groups,

    onSubmit: (selections, state) => {
      console.log(`[${logLabel}] übernommen`, selections, state)

      const selectedPackage = getSelectionCode(selections, groupId)

      applyQ7Q9FollowupPackageChoice(selectedPackage)
    },

    onCancel: () => {
      clearSelectedQ7Q9PackagesExceptMode()

      console.log(`[${logLabel}] abgebrochen → Pakete zurückgesetzt`)
    }
  })
}


/* ============================================================
   POPUP PWB YN1
============================================================ */

function maybeOpenPwbYn1FollowupModal(changedCode, stateBeforeChange = {}) {
  const pwb = document.querySelector('label[data-auicode="PWB_JV"] input')
  const yn1 = document.querySelector('label[data-auicode="YN1_Q7Q9"] input')
  const yfb = document.querySelector('label[data-auicode="YFB_Q7Q9"] input')

  if (!pwb?.checked) return

  if (
    changedCode === 'YFB_Q7Q9' &&
    yfb?.checked &&
    stateBeforeChange['YN1_Q7Q9']
  ) {
    return
  }

  if (
    (changedCode === 'YN1_Q7Q9' && yn1?.checked) ||
    (changedCode === 'YFB_Q7Q9' && yfb?.checked)
  ) {
    openQ7Q9FollowupModal(
      'q7q9_yn1_package_choice',
      'Q7Q9 Modal PWB_JV / YN1',
      changedCode
    )
  }
}

/* ============================================================
   POPUP PWD_QM YN2
============================================================ */

function maybeOpenPwdQmYn2FollowupModal(changedCode, stateBeforeChange = {}) {
  const pwdQm = document.querySelector('label[data-auicode="PWD_QM"] input')
  const yn2 = document.querySelector('label[data-auicode="YN2_Q7Q9"] input')
  const yfb = document.querySelector('label[data-auicode="YFB_Q7Q9"] input')

  if (!pwdQm?.checked) return

  if (
    changedCode === 'YFB_Q7Q9' &&
    yfb?.checked &&
    stateBeforeChange['YN2_Q7Q9']
  ) {
    return
  }

  if (
    (changedCode === 'YN2_Q7Q9' && yn2?.checked) ||
    (changedCode === 'YFB_Q7Q9' && yfb?.checked)
  ) {
    openQ7Q9FollowupModal(
      'q7q9_yn2_package_choice',
      'Q7Q9 Modal PWD_QM / YN2',
      changedCode
    )
  }
}

/* ============================================================
   POPUP PWD_QM YFA
============================================================ */

function maybeOpenPwdQmYfaFollowupModal(changedCode) {
  const pwdQm = document.querySelector('label[data-auicode="PWD_QM"] input')
  const yfa = document.querySelector('label[data-auicode="YFA_Q7Q9"] input')

  if (!pwdQm?.checked) return

  if (changedCode === 'YFA_Q7Q9' && yfa?.checked) {
    openQ7Q9FollowupModal(
      'q7q9_yfa_package_choice',
      'Q7Q9 Modal PWD_QM / YFA',
      'YFA_Q7Q9'
    )
  }
}

/* ============================================================
   POPUP PWD_QX YFA
============================================================ */

function maybeOpenPwdQxYfaFollowupModal(changedCode) {
  const pwdQx = document.querySelector('label[data-auicode="PWD_QX"] input')
  const yfa = document.querySelector('label[data-auicode="YFA_Q7Q9"] input')

  if (!pwdQx?.checked) return

  if (changedCode === 'YFA_Q7Q9' && yfa?.checked) {
    openQ7Q9FollowupModal(
      'q7q9_yfa_pwd_qx_package_choice',
      'Q7Q9 Modal PWD_QX / YFA',
      changedCode
    )
  }
}

/* ============================================================
   BACKGROUND
============================================================ */

function updateBackgroundImage() {
  const PWB_JV = document.querySelector('label[data-auicode="PWB_JV"] input')?.checked
  const PWD_QM = document.querySelector('label[data-auicode="PWD_QM"] input')?.checked
  const PWD_QX = document.querySelector('label[data-auicode="PWD_QX"] input')?.checked
  const package7HH = document.querySelector('label[data-auicode="7HH_Q7Q9"] input')?.checked
  const YN1_Q7Q9 = document.querySelector('label[data-auicode="YN1_Q7Q9"] input')?.checked
  const YN2_Q7Q9 = document.querySelector('label[data-auicode="YN2_Q7Q9"] input')?.checked

 if (YN1_Q7Q9 || YN2_Q7Q9) {
    setTimeout(() => {
      ['7HH_Q7Q9', '7HF_Q7Q9', '7HM_Q7Q9'].forEach((code) => {
        document.getElementById(`${code}-img`)?.remove()
      })
    }, 0)
 }

  const seatConfig = String(getStoredComponentChoice('q7_seven_seater') ?? '0')
  const img = document.getElementById('front_background_image')
  if (!img) return

  console.log('[Q7 seatConfig]', seatConfig)
  console.log("Carmodel: " + getCarmodelId());
  // Abfrage welche Sitzkonfiguration und welches Paket - passendes Hintergrundbild einblenden
  //if (seatConfig === '3') {
  if ( getCarmodelId() === '115' || getCarmodelId() === '118') { // Q7 SUV / Q9 SUV
    if (PWD_QM) {
      img.src = 'img/06_paketauswahl/q7_q9/au546_q7_paketauswahl_serie/au546_q7_q4q_n3q_99p_qm_paketauswahl_basis.png'
    } else if (PWD_QX) {
      img.src = 'img/06_paketauswahl/q7_q9/au546_q7_paketauswahl_serie/au546_q7_q4q_n3q_99p_qx_paketauswahl_basis.png'
    } else {
      img.src = 'img/06_paketauswahl/q7_q9/au546_q7_paketauswahl_serie/au546_q7_q1d_n1f_99m_jv_paketauswahl_basis.png'
    }
    /*} else if (package7HH) {
      img.src = 'img/06_paketauswahl/q7q9/q7q9_7hh_paketauswahl_7s33333.png'
    } else {
      img.src = 'img/06_paketauswahl/q7q9/q7q9_199_paketauswahl_7s3333333.png'
    }*/
    return
  }
  if (( getCarmodelId() === '116') || ( getCarmodelId() === '117') || ( getCarmodelId() === '119') || ( getCarmodelId() === '120')) { // Q7 SUV S line / SQ7 / SQ9
    if (PWD_QM) {
      img.src = 'img/06_paketauswahl/q7_q9/au546_q7_paketauswahl_sport/au546_q7_q4q_n3q_99q_qm_paketauswahl_basis.png'
    } else if (PWD_QX) {
      img.src = 'img/06_paketauswahl/q7_q9/au546_q7_paketauswahl_sport/au546_q7_q4q_n3q_99q_qx_paketauswahl_basis.png'
    } else {
      img.src = 'img/06_paketauswahl/q7_q9/au546_q7_paketauswahl_sport/au546_q7_q1d_n1f_99l_jv_paketauswahl_basis.png'
    }
    return
  }

}

export {
  addListeners_q7q9,
  checkLocks_q7q9,
  getImages_q7q9,
  getPackageImages_q7q9
}